import { useAuth } from '@/contexts/AuthContext';

export function useUserScope() {
  const { userProfile } = useAuth();

  const isAdmin = userProfile?.is_admin ?? false;
  const personaId = (userProfile as any)?.persona_id as string | null;
  const salesRepName = (userProfile as any)?.sales_rep_name as string | null;
  const shouldScope = !isAdmin && (!!personaId || !!salesRepName);

  return { isAdmin, personaId, salesRepName, shouldScope };
}
